/*
 * Scrolling Text Component - OPTIMIZED VERSION
 * Deferred initialization to avoid blocking LCP
 */

// Defer initialization until after page load and idle time
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollingTextWhenIdle);
} else {
  initScrollingTextWhenIdle();
}

function initScrollingTextWhenIdle() {
  // Use requestIdleCallback if available, otherwise setTimeout
  const deferInit = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
  
  deferInit(() => {
    if (typeof ScrollingText !== "function") {
      class ScrollingText extends HTMLElement {
        constructor() {
          super();
          // Defer heavy initialization
          this._initialized = false;
        }

        connectedCallback() {
          // Only initialize when element is in DOM and visible
          if (!this._initialized) {
            this._setupObserver();
          }
        }

        _setupObserver() {
          const intersectionObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              if (!this._initialized) {
                this._initialize();
              }
              if (this._scrollingText) {
                this._scrollingText.start(this._direction);
              }
            } else {
              if (this._scrollingText) {
                this._scrollingText.stop();
              }
            }
          }, {
            rootMargin: '100px' // Start initializing slightly before visible
          });
          intersectionObserver.observe(this);
        }

        _initialize() {
          this._initialized = true;
          
          const ScrollingTextEngine = (function () {
            function getWidth(element) {
              var rect = element.getBoundingClientRect();
              return rect.right - rect.left;
            }

            function ScrollingTextEngine(box, speed) {
              var inner_element = (box.children && box.children[0]) || null;
              if (!inner_element) throw "No child node found";

              inner_element.style.position = "relative";

              this.position = 0;
              this.speed = speed;
              this.box_width = getWidth(box);
              this.inner_element_width = getWidth(inner_element);
              this.box = box;
              this.inner_element = inner_element.cloneNode(true);
              setUpChildrens.call(this);
            }

            function refreshWidths() {
              this.box_width = getWidth(this.box);
              this.inner_element_width = getWidth(this.box.children[0]);
            }

            function calculateNumElements() {
              return Math.ceil(this.box_width / this.inner_element_width) + 1;
            }

            function setUpChildrens() {
              var qty = calculateNumElements.call(this);
              if (qty > this.box.children.length) {
                for (var i = this.box.children.length; i < qty; i++)
                  this.box.appendChild(this.inner_element.cloneNode(true));
              } else if (qty < this.box.children.length) {
                for (var i = qty; i < this.box.children.length; i++)
                  this.box.removeChild(this.box.lastChild);
              }
            }

            function nextFrame(delta, direction) {
              var self = this;
              refreshWidths.call(this);
              setUpChildrens.call(this);
              Array.prototype.forEach.call(this.box.children, function (el) {
                if (direction == "rtl") {
                  el.style.transform = `translateX(${self.position}px)`;
                } else {
                  el.style.transform = `translateX(${-self.position}px)`;
                }
              });
              this.position += (this.speed * delta) / 1000;
              if (this.position >= this.inner_element_width)
                this.position = this.position % this.inner_element_width;
            }

            ScrollingTextEngine.prototype = {
              start: function (direction) {
                this._running = true;
                var self = this;
                var last_time = null;
                var loop_func = function () {
                  if (!self._running) return;
                  var now = Date.now();
                  var delta = last_time === null ? 0 : now - last_time;
                  nextFrame.call(self, delta, direction);
                  last_time = now;
                  window.requestAnimationFrame(loop_func);
                };
                window.requestAnimationFrame(loop_func);
              },

              stop: function () {
                this._running = false;
              },
            };

            return ScrollingTextEngine;
          })();

          const speed = window.innerWidth > 768 
            ? parseInt(this.dataset.scrollingSpeed) 
            : parseInt(this.dataset.scrollingSpeed) / 1.5;
          this._direction = this.dataset.scrollingDirection;
          
          this._scrollingText = new ScrollingTextEngine(this, speed);

          if (this.dataset.pauseOnHover == "true") {
            let windowInFocus = true;

            window.addEventListener("blur", () => { windowInFocus = false; });
            window.addEventListener("focus", () => { windowInFocus = true; });

            this.addEventListener('mouseover', () => {
              if (windowInFocus && this._scrollingText) {
                this._scrollingText.stop();
              }
            });

            this.addEventListener('mouseout', () => {
              if (windowInFocus && this._scrollingText) {
                this._scrollingText.start(this._direction);
              }
            });
          }
        }
      }

      if (typeof customElements.get("scrolling-text") == "undefined") {
        customElements.define("scrolling-text", ScrollingText);
      }
    }
  }, { timeout: 2000 }); // Max wait 2 seconds
}